var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{attrs:{"id":"audio","preload":"auto"}},[_c('source',{attrs:{"src":"/static/momo.mp3","type":"audio/ogg"}})])
}]

export { render, staticRenderFns }